import * as React from 'react';
import { useDefaultFilters } from './DefaultFiltersContext';
import { SavedFilter, SelectedSavedFilters } from './types';

export const useSelectedSavedFilters = () => {
  const [selectedSavedFilters, setSelectedSavedFilters] =
    React.useState<SelectedSavedFilters>();
  const [defaultFilters] = useDefaultFilters();

  React.useEffect(() => {
    setSelectedSavedFilters(defaultFilters);
  }, [defaultFilters]);

  const handleOnSelectedSavedFiltersChange = ({
    filter,
    key,
  }: {
    filter: SavedFilter;
    key: string;
  }) => {
    const newFilters = { ...selectedSavedFilters };
    // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
    newFilters[key] = filter;
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    setSelectedSavedFilters(newFilters);
  };

  return {
    selectedSavedFilters,
    setSelectedSavedFilters: handleOnSelectedSavedFiltersChange,
  };
};
